export default __webpack_public_path__ + "media/images/banners/bnr_jr-61aab828e14625a4b101be8bb172b5c2.png";